document.addEventListener("DOMContentLoaded", function() {
    const header = document.querySelector(".header"); // Update with your header's class or ID
    console.log('head',header)
    const scrollThreshold = 64;

    window.addEventListener("scroll", function() {
        if (window.scrollY > scrollThreshold) {
            header.classList.add("scrolled");
        } else {
            header.classList.remove("scrolled");
        }
    });
});
